import { ExternalDashboardService } from './external-dashboard.service';

export default angular
  .module('sfMobile.services.external-dashboard', [
    'sfMobile.services.external-dashboard-api',
  ])
  .service('externalDashboardService', ExternalDashboardService).name;
